import { useState } from "react";
import { materials } from "@/data/content";

export function MaterialExplorer() {
  const [activeId, setActiveId] = useState(materials[0].id);
  const active = materials.find((m) => m.id === activeId) ?? materials[0];

  return (
    <div className="mt-10 grid gap-8 lg:grid-cols-[1fr_1.1fr]">
      <div>
        <ul className="grid grid-cols-2 gap-3 sm:grid-cols-3">
          {materials.map((m) => {
            const on = m.id === active.id;
            return (
              <li key={m.id}>
                <button
                  type="button"
                  aria-pressed={on}
                  onClick={() => setActiveId(m.id)}
                  className="group flex w-full flex-col gap-2 rounded-sm border p-2 text-left motion-craft transition-colors"
                  style={{ borderColor: on ? "var(--color-brass)" : "var(--color-hairline)" }}
                >
                  <span
                    aria-hidden="true"
                    className="block h-14 w-full rounded-[2px] motion-craft transition-transform group-hover:scale-[1.02]"
                    style={{ background: m.swatch }}
                  />
                  <span className="text-xs font-semibold leading-tight">{m.name}</span>
                  <span className="text-[0.65rem] uppercase tracking-[0.12em] text-muted-foreground">
                    {m.family}
                    {on && <span className="sr-only"> (selected)</span>}
                  </span>
                </button>
              </li>
            );
          })}
        </ul>
      </div>

      <div className="surface-card p-6 sm:p-8" aria-live="polite">
        <p className="eyebrow">{active.family}</p>
        <h3 className="display-md mt-2">{active.name}</h3>
        <dl className="mt-6 space-y-5 text-sm">
          <div>
            <dt className="font-semibold">Appearance</dt>
            <dd className="mt-1 text-muted-foreground">{active.appearance}</dd>
          </div>
          <div>
            <dt className="font-semibold">Natural variation</dt>
            <dd className="mt-1 text-muted-foreground">{active.variation}</dd>
          </div>
          <div>
            <dt className="font-semibold">Suits</dt>
            <dd className="mt-1 text-muted-foreground">{active.suits.join(" · ")}</dd>
          </div>
          <div>
            <dt className="font-semibold">Example creation</dt>
            <dd className="mt-1 text-muted-foreground">{active.example}</dd>
          </div>
        </dl>
        <p className="mt-6 border-t border-hairline pt-4 text-xs text-muted-foreground">
          Materials come and go with what Paul can source. Ask Paul about current availability before settling on
          one.
        </p>
      </div>
    </div>
  );
}
